import classes from './serviceAccountDetailsComponent.scss';
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";

const FailedAccountHeader = (props) => {
  let strings = getLocalizedStrings("ServiceAccountDetails");
  let details=props.accountData;
  let streetAdd=(props.accountData.contractAccountStreetAddress)? (props.accountData.contractAccountStreetAddress).toLowerCase() : null;
  let acctCity=(props.accountData.city) ? (props.accountData.city).toLowerCase() : null;
  const serviceAccountDetailsJSX = <div className={classes.sceServiceAccInfoOuter}>
   {(details.houseNumber!=="" && details.contractAccountStreetAddress!=="") ? 
   <div className={classes.sceServiceAccInfo}>
   <div className={classes.serviceAccountDetails}><span className={classes.actInfo}> {details.houseNumber} {streetAdd}, {acctCity},  {details.state} {details.zipCode}</span>&nbsp;<span className={classes.accountData}>{" - Acct.  "} {details.contractAccountNumber}</span>
   </div>
   </div> 
   :
   <div className={classes.sceServiceAccInfo}>
      <div className={classes.serviceAccountDetails}><span className={classes.actInfo}>{acctCity},  {details.state} {details.zipCode}</span>&nbsp;<span className={classes.accountData}>{" - Acct.  "} {details.contractAccountNumber}</span>
  </div>
  </div>
   }
  </div>;

  return (
    <div>
      {serviceAccountDetailsJSX}
    </div>
  );
};

export default FailedAccountHeader;